import { useNavigate } from "react-router-dom"

const StartYourFreeTrial = () => {
    const navigate = useNavigate();

    return (
        <section className="bg-sky-50 py-20">
            <div className="max-w-7xl mx-auto px-6">
                <div className="bg-white rounded-3xl shadow-sm border border-slate-200 p-8 lg:p-12">
                    <div className="grid lg:grid-cols-2 gap-10 items-center">
                        {/* Content */}
                        <div>
                            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-4 py-1 text-sm font-medium">
                                Start Today
                            </span>

                            <h2 className="different_heading mt-5 text-3xl lg:text-4xl font-bold text-slate-900">
                                Start Your Free Trial Today
                            </h2>

                            <p className="mt-5 text-slate-600 leading-8">
                                Choose a monthly or yearly plan that fits your church. Upgrade,
                                downgrade, or cancel anytime—no long-term commitments, just the
                                flexibility you need.
                            </p>
                        </div>

                        {/* CTA */}
                        <div className="flex lg:justify-end">
                            <button
                                className="px-5 py-[10px] mt-8 bg-secondary text-lg text-white font-medium rounded-[8px] hover:shadow-md hover:opacity-90"
                                onClick={() => navigate("/free-trial")}
                            >
                                Get Started Free
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default StartYourFreeTrial